import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export const GiftIcon = ({ title = 'Gift', ...props }: CreateIconComponentProps): JSX.Element => (
  <CreateIconComponent title={title} viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.407 1.63C7.69.35 9.78.39 11.075 1.688c.402.402.693.95.892 1.654.2-.704.49-1.252.893-1.654C14.156.39 16.246.349 17.528 1.63c1.173 1.173 1.237 3.022.246 4.32h2.922c.72 0 1.304.585 1.304 1.305v4.348c0 .72-.584 1.304-1.304 1.304v9.131c0 .72-.584 1.305-1.305 1.305H4.61c-.72 0-1.305-.584-1.305-1.305v-9.13c-.72 0-1.304-.585-1.304-1.305V7.256c0-.72.584-1.304 1.304-1.304H6.16c-.99-1.3-.926-3.148.247-4.321zm1.845 1.845c-.246.246-.238.685.056.979l.025.022c.15.123.53.246 1.122.336l.155.021-.004-.034-.035-.235c-.093-.56-.218-.91-.34-1.033-.294-.294-.733-.302-.979-.056zm7.375.979c.294-.294.302-.733.056-.979s-.685-.238-.978.056c-.14.14-.28.57-.376 1.268l-.004.034.156-.021c.591-.09.971-.213 1.122-.336l.024-.022zM19.39 8.56v1.74h-6.087V8.56h6.087zm-8.695 0v1.74H4.609V8.56h6.087zm0 4.349H5.913v7.826h4.783V12.91zm2.608 7.826h4.783V12.91h-4.783v7.826z"
    />
  </CreateIconComponent>
);

export default GiftIcon;
